import request from '../kernel/request'

export default {
    group:{
        list(params) {
            return request.get('group', params)
        },
        listBy(params) {
            return request.get('group/by', params)
        },
        page(params) {
            return request.get('group/page', params)
        },
        save(data) {
            return request.post(`group/save`, data)
        },
        update(data) {
            return request.put(`group`, data)
        },
        delete(id) {
            return request.delete('group/'+id)
        },
        load(id) {
            return request.get('group/' + id)
        },
        edit(id) {
            return request.get('group/edit/' + id)
        },

    },
    courseGroup:{
        list(params) {
            return request.get('courseGroup', params)
        },
        save(data) {
            return request.post(`courseGroup`, data)
        },
        update(data) {
            return request.put(`courseGroup`, data)
        },
        upRank(data) {
            return request.put(`courseGroup/upRank`, data)
        },
        delete(id) {
            return request.delete('courseGroup/'+id)
        },
        load(id) {
            return request.get('courseGroup/' + id)
        }
    }
}